import { render, staticRenderFns } from "./CurrencyTransform.vue?vue&type=template&id=a23275ac&scoped=true&"
import script from "./CurrencyTransform.vue?vue&type=script&lang=js&"
export * from "./CurrencyTransform.vue?vue&type=script&lang=js&"
import style1 from "./CurrencyTransform.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CurrencyTransform.vue?vue&type=style&index=2&id=a23275ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23275ac",
  null
  
)

export default component.exports